import {FC} from 'react'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

const Error404: FC = () => {
  return (
    // <>
    //   {/* begin::Title */}
    //   <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>Oops!</h1>
    //   {/* end::Title */}

    //   {/* begin::Text */}
    //   <div className='fw-semibold fs-6 text-gray-500 mb-7'>We can't find that page.</div>
    //   {/* end::Text */}

    //   {/* begin::Illustration */}
    //   <div className='mb-3'>
    //     <img
    //       src={toAbsoluteUrl('/media/auth/404-error.png')}
    //       className='mw-100 mh-300px theme-light-show'
    //       alt=''
    //     />
    //     <img
    //       src={toAbsoluteUrl('/media/auth/404-error-dark.png')}
    //       className='mw-100 mh-300px theme-dark-show'
    //       alt=''
    //     />
    //   </div>
    //   {/* end::Illustration */}

    //   {/* begin::Link */}
    //   <div className='mb-0'>
    //     <Link to='/dashboard' className='btn btn-sm btn-primary'>
    //       Return Home
    //     </Link>
    //   </div>
    //   {/* end::Link */}
    // </>

    <div className="position-absolute right-0 r-0 top-0 w-100 h-100">
      <div
        className="w-100 h-100 error error-3 d-flex flex-row-fluid bgi-size-cover bgi-position-center"
        style={{
          backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-13.jpg")})`
        }}
      >
        <div className="px-10 px-md-30 py-10 py-md-0 d-flex flex-column justify-content-center">
        <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>Oops!</h1>
          <p className="font-size-h1 font-weight-boldest text-white">
            Parece que não conseguimos encontrar
            <br />
            a página que você está procurando.
          </p>
          <p className="font-size-h4 line-height-md text-white">
            Pode haver um erro de ortografia na URL inserida,
            <br />
            ou a página que você está procurando pode não existir mais.
          </p>
        </div>
      </div>
    </div>
  )
}

export {Error404}
